import React from 'react';
import '../styles/WhatsAppButton.css';

const WHATSAPP_NUMBER = '523318484205'; // Cambia este número
const WHATSAPP_MESSAGE = '¡Hola! Me interesa conocer más sobre sus servicios de desarrollo web. ';

const WhatsAppButton = () => {
  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="whatsapp-float">
      <div className="whatsapp-float__tooltip">
        ¿Necesitas ayuda? ¡Escríbenos!
      </div>
      <button
        className="whatsapp-float__btn"
        onClick={handleClick}
        aria-label="Contactar por WhatsApp"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.004 0C7.165 0 .002 7.161.002 15.997c0 2.82.737 5.574 2.137 7.998L.01 32l8.186-2.09A15.95 15.95 0 0016.004 32C24.838 32 32 24.836 32 15.997 32 7.161 24.838 0 16.004 0zm0 29.39a13.36 13.36 0 01-7.213-2.1l-.517-.307-5.357 1.37 1.394-5.217-.337-.536a13.32 13.32 0 01-2.065-7.103c0-7.38 6.008-13.387 13.395-13.387 7.38 0 13.387 6.008 13.387 13.387S23.384 29.39 16.004 29.39zm7.34-10.023c-.402-.201-2.38-1.175-2.75-1.31-.37-.133-.639-.2-.908.202-.268.4-1.04 1.31-1.276 1.578-.234.268-.47.302-.872.1-.402-.2-1.697-.625-3.232-1.994-1.195-1.065-2.001-2.38-2.236-2.782-.234-.402-.025-.62.176-.82.181-.18.402-.47.603-.704.201-.235.268-.402.402-.67.134-.268.067-.503-.033-.704-.1-.2-.908-2.189-1.243-2.995-.328-.786-.66-.68-.908-.692l-.773-.013c-.268 0-.704.1-1.073.503-.37.401-1.41 1.376-1.41 3.356 0 1.98 1.443 3.893 1.644 4.161.2.268 2.838 4.331 6.879 6.074.961.415 1.712.662 2.297.848.965.307 1.844.264 2.538.16.774-.115 2.38-.973 2.716-1.912.335-.94.335-1.745.234-1.912-.1-.168-.369-.268-.77-.47z" />
        </svg>
      </button>
    </div>
  );
};

export default WhatsAppButton;
